module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-pickwick-00.1@2x.51a4edcf.jpg";